import { NewselaGlobalLayoutV2 } from "@/base/NewselaGlobalLayoutV2/NewselaGlobalLayoutV2";

export { NewselaGlobalLayoutV2 };
